import Helpers from '../../../core/Helpers';

class Utils {

    static unique(length) {
        return Helpers.unique(length);
    }

    static isJSON(str) {
        return Helpers.isJSON(length);
    }

    static concatByteArrays(target, source) {

        let bytearray = new Uint8Array( target.length + source.length );

        for( var i = 0; i < bytearray.length; i++ ) {
            bytearray[i] = ( i < target.length ) ? target[i] : source[i - target.length];
        }

        return bytearray;
    }

    static btoa(data) {

        if ( typeof data === "string" ) {
            return btoa(data);

        } else {
            return btoa(String.fromCharCode.apply(null, data));
        }
    }

    static atob(encoded) {
        return new TextDecoder().decode(new Uint8Array(atob(encoded).split("").map(function(c) { return c.charCodeAt(0); })));
    }

    static atobAsArray(encoded) {
        return new Uint8Array(atob(encoded).split("").map(function(c) { return c.charCodeAt(0); }));
    }

    static arrayBufferToString(buf) {
        return String.fromCharCode.apply(null, new Uint8Array(buf));
    }

    static stringToBytes(byteStr) {

        var bytes = new Uint8Array(byteStr.length)

        for ( var i = 0; i < byteStr.length; i++ ) {
            bytes[i] = byteStr.charCodeAt(i)
        }

        return bytes;
    }
}

export default Utils;
